import LoaderImage from 'common/components/LoaderImage';
import React, { useState, useEffect } from 'react';

const TchWiseSlider = (props) => {


    return (

        <div className="pdf" style={{ width: '100%', height: '96vh' }}>
            <iframe src={require("common/images/loader.gif")} title="Time Table Preview" id="viewer" style={{ width: '100%', height: '100%' }} />
        </div>
    )



}
export default TchWiseSlider